import { createFeatureSelector, createSelector } from '@ngrx/store';
import { emailFoldersFeatureKey, EmailFolderState } from '../reducers/emailfolders.reducer';

export const selectEmailFolders = createFeatureSelector<EmailFolderState>(emailFoldersFeatureKey);

export const getEmailFolders = createSelector(selectEmailFolders, (data) => data.emailFolders);
export const getEmailFoldersFetched = createSelector(selectEmailFolders, (data) => !!data.emailFolders);
export const getEmailFolderById = (props: { id: number }) => createSelector(getEmailFolders, (data) => data?.find((f) => f.Id === props.id));
